import '../stylesheets/ProjectCard.css'

const ProjectCard = (project) => {
    return <>
        <div className={"proj-card-container shadow-bg"}>
            <img className="proj-image" src={project?.image} alt={project?.title + " image"} />
            <div className="proj-text">
                <div className="proj-links">
                    <h1>{project?.title}</h1>
                    {project?.link ? <a className={project.color} href={project.link}>Paper</a> : <></>}
                    {project?.repo ? <a className={project.color} href={project.repo}>Repo</a> : <></>}
                </div>
                <h2 className={"alt-text " + project?.color}>Description</h2>
                <p>{project?.description}</p>
            </div>
        </div>
    </>;
}

export default ProjectCard;